import { useState } from "react";
import { supabase } from "../supabase";
import { C } from "../lib/constants";
import { isPremiumWorker } from "../lib/helpers";
import { Btn } from "./ui/Btn";
import { Av } from "./ui/Av";
import { Field } from "./ui/Field";
import { PremiumBadge } from "./WorkerProfile";

const createWorkRequest = async (payload) => {
  // Paso 38: solicitud estable y coherente.
  // La solicitud siempre guarda datos mínimos del cliente y del trabajador para
  // que aparezca igual en Mi Obra Cliente y Portal Trabajador.
  const safePayload = Object.fromEntries(
    Object.entries(payload || {}).filter(([, value]) => value !== undefined)
  );

  if (!safePayload.cliente_user_id) {
    return { data: null, error: { message: "Inicia sesión para crear una solicitud." } };
  }

  const { data, error } = await supabase
    .from("solicitudes")
    .insert([safePayload])
    .select("*")
    .maybeSingle();

  return { data, error };
};


export const RequestWorkModal = ({worker=null, onClose, user=null, profile=null, setScreen}) => {
  const [form, setForm] = useState(() => ({
    nombre: profile?.nombre || profile?.name || "",
    telefono: profile?.telefono || profile?.phone || profile?.whatsapp || "",
    oficio: worker?.oficio || worker?.trade || "",
    zona: worker?.zona || worker?.zone || worker?.ciudad || "Los Mochis",
    descripcion:"",
    presupuesto:"",
    fecha:"",
  }));
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const upd = (k,v) => setForm(f => ({...f, [k]:v}));

  const enviar = async () => {
    setErrorMsg("");

    if (!form.nombre.trim() || !form.telefono.trim() || !form.descripcion.trim()) {
      setErrorMsg("Completa nombre, teléfono y descripción del trabajo.");
      return;
    }

    setSaving(true);

    const payload = {
      oficio: form.oficio || worker?.oficio || "No especificado",
      zona: form.zona || "Los Mochis",
      descripcion: form.descripcion.trim(),
      presupuesto: form.presupuesto ? Number(String(form.presupuesto).replace(/[^\d.]/g,"")) : null,
      fecha_preferida: form.fecha || null,
      trabajador_id:        worker?.id       || null,
      trabajador_user_id:   worker?.user_id  || null,
      trabajador_nombre:    worker?.nombre   || worker?.name  || "Trabajador",
      trabajador_telefono:  worker?.telefono || worker?.phone || worker?.whatsapp || null,
      trabajador_oficio:    worker?.oficio   || worker?.trade || form.oficio || null,
      trabajador_zona:      worker?.zona     || worker?.zone  || worker?.ciudad || form.zona || null,
      cliente_user_id:      user?.id         || null,
      cliente_id:           user?.id         || null, // FICIO: columna canónica spec
      cliente_nombre:       profile?.nombre  || user?.email || "",
      cliente_telefono:     String(profile?.telefono || "").replace(/\D/g,""),
      estado:               "pendiente", // FICIO: columna canónica spec
      status: "nueva",
      flujo: "cotizacion",
      mediation_fee: 500,
      cliente_autorizo: false,
      trabajador_concluyo: false,
      cliente_concluyo: false,
      origen: worker ? "perfil_trabajador" : "solicitud_general",
    };

    const { error } = await createWorkRequest(payload);

    if (error) {
      console.warn("Error solicitud:", error);
      setErrorMsg(error.message);
      setSaving(false);
      return;
    }

    // FICIO: notificar al trabajador por WhatsApp inmediatamente al crear la solicitud
    const wPhone = String(worker?.telefono || worker?.phone || worker?.whatsapp || "").replace(/\D/g,"");
    const clienteNombre = profile?.nombre || user?.email || "un cliente";
    if (wPhone) {
      const msg = encodeURIComponent(
        `Hola, tienes una nueva solicitud en Ficio de ${clienteNombre}. ` +
        `Entra a ficio.com.mx para verla y aceptarla.`
      );
      window.open(`https://wa.me/52${wPhone}?text=${msg}`, "_blank");
    }

    setDone(true);
    setSaving(false);
  };


  if (!user) {
    return (
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:18}}>
        <div style={{background:C.surface,borderRadius:22,maxWidth:420,width:"100%",padding:24,textAlign:"center",boxShadow:"0 18px 60px rgba(0,0,0,.25)"}}>
          <div style={{fontSize:50,marginBottom:10}}>🔐</div>
          <div style={{fontFamily:"Georgia, serif",fontSize:24,fontWeight:900,color:C.text,marginBottom:8}}>Inicia sesión</div>
          <div style={{color:C.sub,fontSize:14,lineHeight:1.6,marginBottom:18}}>Para solicitar cotización o contactar a un trabajador necesitas una cuenta de cliente.</div>
          <Btn full color={C.accent} onClick={()=>{onClose?.();setScreen?.("cliente-login");}}>Iniciar sesión</Btn>
          <div style={{height:10}}/>
          <Btn full outline color={C.muted} onClick={onClose}>Cerrar</Btn>
        </div>
      </div>
    );
  }

  const abrirWhatsapp = () => {
    if (!worker?.phone && !worker?.telefono) return;

    const phone = String(worker.phone || worker.telefono || "").replace(/\D/g,"");
    const msg = encodeURIComponent(
`Hola ${worker.nombre || worker.name || ""} 👋

Vi tu perfil en FICIO y necesito cotizar un trabajo.

Servicio: ${form.oficio || worker.oficio || "No especificado"}
Zona: ${form.zona || "Los Mochis"}
Descripción: ${form.descripcion || "Quiero más información sobre tu servicio."}

Mi nombre es ${form.nombre || "cliente"}.
Mi teléfono es ${form.telefono || ""}.`
    );

    window.open(`https://wa.me/52${phone}?text=${msg}`, "_blank");
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center",padding:18}}>
      <div style={{background:C.surface,borderRadius:22,maxWidth:560,width:"100%",maxHeight:"90vh",overflowY:"auto",padding:22,boxShadow:"0 -8px 32px rgba(0,0,0,0.25)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div>
            <div style={{fontFamily:"'Georgia',serif",fontSize:22,fontWeight:900,color:C.text}}>Solicitar trabajo</div>
            <div style={{color:C.muted,fontSize:12}}>
              {worker ? `Solicitud para ${worker.nombre || worker.name}` : "Describe lo que necesitas y FICIO lo guarda"}
            </div>
          </div>
          <button onClick={onClose} style={{background:C.faint,border:"none",borderRadius:10,padding:"8px 12px",cursor:"pointer",color:C.sub}}>
            ✕ Cerrar
          </button>
        </div>

        {done ? (
          <div style={{textAlign:"center",padding:"20px 0"}}>
            <div style={{fontSize:58,marginBottom:14}}>✅</div>
            <div style={{fontFamily:"Georgia, serif",fontSize:22,fontWeight:900,color:C.text,marginBottom:6}}>
              Solicitud guardada
            </div>
            <div style={{color:C.sub,fontSize:13,lineHeight:1.6,marginBottom:18}}>
              Tu solicitud ya quedó registrada en FICIO. {worker ? "También puedes abrir WhatsApp para hablar directo con el trabajador." : "El equipo podrá darle seguimiento desde el admin."}
            </div>
            {worker && (
              <Btn full color="#25D366" onClick={abrirWhatsapp}>
                💬 Abrir WhatsApp con el trabajador
              </Btn>
            )}
            <div style={{height:10}}/>
            <Btn full outline color={C.muted} onClick={onClose}>
              Cerrar
            </Btn>
          </div>
        ) : (
          <>
            {worker && (
              <div style={{background:"linear-gradient(135deg,#FFF8E1,#FFFFFF)",border:"1.5px solid #D99A0035",borderRadius:16,padding:14,marginBottom:14}}>
                <div style={{display:"flex",gap:12,alignItems:"center"}}>
                  <Av letters={worker.avatar} color={worker.color || C.accent} size={48}/>
                  <div style={{flex:1}}>
                    <div style={{fontFamily:"Georgia, serif",fontSize:16,fontWeight:900,color:C.text}}>{worker.nombre || worker.name}</div>
                    <div style={{color:C.sub,fontSize:12}}>{worker.oficio || worker.trade} · {worker.zona || worker.zone}</div>
                  </div>
                  {isPremiumWorker(worker) && <PremiumBadge small/>}
                </div>
              </div>
            )}

            {errorMsg && (
              <div style={{background:C.redL,border:`1.5px solid ${C.red}35`,borderRadius:12,padding:"10px 12px",color:C.red,fontSize:12,marginBottom:12}}>
                {errorMsg}
              </div>
            )}

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
              <Field label="Tu nombre" value={form.nombre} onChange={v=>upd("nombre",v)} placeholder="Ej. Alejandro"/>
              <Field label="WhatsApp" value={form.telefono} onChange={v=>upd("telefono",v)} placeholder="668..."/>
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
              <Field label="Servicio" value={form.oficio} onChange={v=>upd("oficio",v)} placeholder="Ej. Jardinería"/>
              <Field label="Zona" value={form.zona} onChange={v=>upd("zona",v)} placeholder="Ej. Centro"/>
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
              <Field label="Presupuesto aprox." value={form.presupuesto} onChange={v=>upd("presupuesto",v)} placeholder="$ Opcional"/>
              <Field label="Fecha preferida" type="date" value={form.fecha} onChange={v=>upd("fecha",v)} placeholder=""/>
            </div>

            <div style={{marginBottom:14}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:800,letterSpacing:0.8,textTransform:"uppercase",marginBottom:7}}>
                Describe el trabajo
              </div>
              <textarea
                value={form.descripcion}
                onChange={e=>upd("descripcion", e.target.value)}
                placeholder="Ej. Necesito instalar pasto sintético en patio de 40 m², con preparación de terreno..."
                rows={5}
                style={{width:"100%",background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 14px",fontSize:13,color:C.text,outline:"none",resize:"vertical",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}
              />
            </div>

            <div style={{background:C.blueL,border:`1.5px solid ${C.blue}25`,borderRadius:12,padding:"11px 13px",marginBottom:14}}>
              <div style={{color:C.blue,fontSize:12,fontWeight:800,marginBottom:2}}>📋 ¿Qué pasa al enviar?</div>
              <div style={{color:C.sub,fontSize:12,lineHeight:1.5}}>
                FICIO guarda tu solicitud para seguimiento. Si elegiste un trabajador, también podrás abrir WhatsApp con un mensaje preparado.
              </div>
            </div>

            <Btn full color={C.accent} onClick={enviar} disabled={saving}>
              {saving ? "Guardando solicitud..." : "Enviar solicitud →"}
            </Btn>
          </>
        )}
      </div>
    </div>
  );
};
